import { put, takeLatest } from 'redux-saga/effects'
import {
  ChangeMailboxTypes,
  ChangeMailboxActionCreators,
} from 'app/reducers/ChangeMailboxRedux'
import { changeMailbox } from 'app/services/api/entities'

export function* checkEmailAvailability({ email }) {
  const response = yield changeMailbox.checkEmailAvailability({ email })

  if (response.success()) {
    const isAvailable = response.data?.available
    const hasForbiddenWords = response.data?.hasForbiddenWords || false
    return yield put(
      ChangeMailboxActionCreators.checkEmailAvailabilitySuccess(
        isAvailable,
        hasForbiddenWords,
      ),
    )
  }

  yield put(
    ChangeMailboxActionCreators.checkEmailAvailabilityFailure(response.data),
  )
}

export function* updateMailbox({ email }) {
  const response = yield changeMailbox.updateMailbox({ email })

  if (response.success()) {
    return yield put(ChangeMailboxActionCreators.updateMailboxSuccess(email))
  }

  yield put(ChangeMailboxActionCreators.updateMailboxFailure(response.data))
}

export default function* changeMailboxSaga() {
  yield takeLatest(
    ChangeMailboxTypes.CHECK_EMAIL_AVAILABILITY_REQUEST,
    checkEmailAvailability,
  )
  yield takeLatest(ChangeMailboxTypes.UPDATE_MAILBOX_REQUEST, updateMailbox)
}
